import PropTypes from 'prop-types'
import { styled, makeStyles, useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

export const ListRecommendedRoot = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[100],
}))

const useScrollWrapStyles = makeStyles({
  root: ({ theme, max }) => ({
    [`@media(max-width: ${max}px)`]: {
      overflowX: 'auto',
      overflowY: 'hidden',
      marginRight: theme.spacing(-2),
      marginLeft: theme.spacing(-2),
      paddingLeft: theme.spacing(2),
    },
  }),
})

export const ScrollWrap = (props) => {
  const { children } = props
  const theme = useTheme()
  const classes = useScrollWrapStyles({ ...props, theme })
  return (
    <Box className={`${classes.root}`}>
      {children}
    </Box>
  )
}

ScrollWrap.propTypes = {
  children: PropTypes.node,
}
